import {
  EASYBIB,
  CITATION_MACHINE,
  BIBME,
  CHEGG,
  EB,
  CM,
  BM,
  CW,
  CTFM,
  EB_DOMAIN,
  CM_DOMAIN,
  BM_DOMAIN,
  CW_DOMAIN,
  CTFM_DOMAIN,
  CM_PRODUCT_NAME,
  CW_PRODUCT_NAME,
  EB_PRODUCT_NAME,
  CTFM_PRODUCT_NAME,
  CITE_THIS_FOR_ME,
  BM_PRODUCT_NAME,
} from '@chegg-wt/core/constants/site'
import { EnumLiteralsOf } from './helpers'

export type Site =
  | typeof EASYBIB
  | typeof CITATION_MACHINE
  | typeof BIBME
  | typeof CHEGG
  | typeof CITE_THIS_FOR_ME

export type ProductName =
  | typeof EB_PRODUCT_NAME
  | typeof CM_PRODUCT_NAME
  | typeof CW_PRODUCT_NAME
  | typeof CTFM_PRODUCT_NAME
  | typeof BM_PRODUCT_NAME

export type SiteInitial = typeof EB | typeof CM | typeof BM | typeof CW | typeof CTFM

export type Domain =
  | typeof EB_DOMAIN
  | typeof CM_DOMAIN
  | typeof BM_DOMAIN
  | typeof CW_DOMAIN
  | typeof CTFM_DOMAIN

export interface SiteEnv {
  siteInitials: SiteInitial
  domain: Domain
}

export interface ClientState {
  citationCount: number
  pageCount: number
  pagesVisited: string[]
  type: string
}

export interface AdLayoutConfig {
  startWidth: number
  name: AdLayoutName
}

export const adLayoutName = {
  sm: 'ucfsmall',
  md: 'ucfmedium',
  lg: 'ucflarge',
  xl: 'ucfxlarge',
} as const

export type AdLayoutName = EnumLiteralsOf<typeof adLayoutName>

export type AdReloadType = 'pagechange' | 'layoutchange'

export interface AdsConfig {
  type: string
  pagetype: string
  pageCount?: number
  citationCount?: number
  layout?: string
}

export interface ErrorPayload {
  msg: string
}
